import latinize from './latinize';

/**
 * @param string
 */
export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * ATTENTION: Require /vendor/latinize/latinize.js to work.
 *
 * @param form
 * @param formSelector
 */
export function latinizeForm(form) {
  // looks for all inputs and selects inside the form
  Array.from(form.querySelectorAll('input[name]:not([type="hidden"])')).forEach(input => {
    if (input.name) {
      let latValue = latinize(input.value);
      if (input.name.includes('name')) latValue = capitalize(latValue);
      input.value = latValue;
    }
  });
}
